module.exports = __webpack_public_path__ + "static/media/bowen-29.6517fbfc.jpg";